import { environment } from "../config/environment";
import { buildDefaultWindows } from "./time-window";
import type { HeyeaSession, OutlookContext, NormalizedAttendee } from "./types";
import type { DateWindow, TimeFinderRequestDto } from "@hai/common";

export interface BuildPayloadInput {
  session: HeyeaSession;
  context: OutlookContext;
  attendees?: NormalizedAttendee[]; // Make attendees overridable
}

export function buildTimeFinderPayload(input: BuildPayloadInput): TimeFinderRequestDto {
  const { session, context, attendees: customAttendees } = input;

  // Use custom attendees if provided, otherwise use context attendees
  const attendeesToUse = customAttendees ? [...customAttendees] : [...(context.attendees || [])];

  // Ensure the Heyea session email is always included as an attendee (role: self)
  const sessionEmail = session.user?.email?.trim();
  if (sessionEmail) {
    const lower = sessionEmail.toLowerCase();
    const exists = attendeesToUse.some((a) => a.email.toLowerCase() === lower);
    if (!exists) {
      attendeesToUse.push({
        email: sessionEmail,
        displayName: sessionEmail.split("@")[0] || sessionEmail,
        role: "self",
      } as NormalizedAttendee);
    }
  }

  const attendees = attendeesToUse.map((attendee) => ({
    id: attendee.email,
    name: attendee.displayName,
    email: attendee.email,
  }));

  return {
    attendees,
    owner: session.user?.id || "",
    durationMinutes: environment.defaultMeetingDurationMinutes,
    mode: "timefinder",
    // buildDefaultWindows returns ISO strings for safer serialization; cast to the DTO shape
    windows: buildDefaultWindows(new Date(), environment.daysVisible) as unknown as DateWindow[],
    slotMinutes: environment.defaultSlotMinutes,
    daysVisible: environment.daysVisible,
    title: context.subject,
    description: context.bodyPreview,
  };
}
